export const sortNames = (
  array: any,
  name: string,
  order: "asc" | "desc" = "asc",
) =>
  order === "asc"
    ? array.sort((a: any, b: any) => b[name]?.localeCompare(a[name]))
    : array.sort((a: any, b: any) => a[name]?.localeCompare(b[name]));
